import {
  Shirt, Store, Smartphone, ShoppingBasket, Leaf, Wrench, CreditCard, PiggyBank, Pill, Utensils, Building2, Laptop, Wheat, Package, Scissors, PencilRuler, FolderOpen,
  type LucideProps,
} from 'lucide-react';
import type { Category } from '@dd/shared';
import { CATEGORY_CONFIG } from '@dd/shared';
import { cn } from './cn';
import { tint } from './tokens';


/** The 17 category icons (Bible 3.0: every category has its own SVG icon). Keys = CATEGORY_CONFIG[c].icon */
const MAP: Record<string, (p: LucideProps) => React.ReactElement> = {
  shirt: (p) => <Shirt {...p} />,
  store: (p) => <Store {...p} />,
  smartphone: (p) => <Smartphone {...p} />,
  basket: (p) => <ShoppingBasket {...p} />,
  leaf: (p) => <Leaf {...p} />,
  wrench: (p) => <Wrench {...p} />,
  card: (p) => <CreditCard {...p} />,
  moneybag: (p) => <PiggyBank {...p} />,
  capsule: (p) => <Pill {...p} />,
  utensils: (p) => <Utensils {...p} />,
  building: (p) => <Building2 {...p} />,
  laptop: (p) => <Laptop {...p} />,
  wheat: (p) => <Wheat {...p} />,
  box: (p) => <Package {...p} />,
  spool: (p) => <Scissors {...p} />,
  pencil: (p) => <PencilRuler {...p} />,
  folder: (p) => <FolderOpen {...p} />,
};

export function CategoryIcon({ category, size = 22, className, color }: { category: Category; size?: number; className?: string; color?: string }) {
  const cfg = CATEGORY_CONFIG[category];
  const Render = MAP[cfg.icon] ?? MAP.folder!;
  return Render({ size, className, color: color ?? cfg.color, strokeWidth: 2, 'aria-hidden': true });
}

/** Round badge with the category icon on a light tint of the category colour (icon + name are always shown together). */
export function CategoryBadge({ category, size = 40, className }: { category: Category; size?: number; className?: string }) {
  const cfg = CATEGORY_CONFIG[category];
  return (
    <span className={cn('inline-flex shrink-0 items-center justify-center rounded-xl', className)} style={{ width: size, height: size, background: tint(cfg.color, 0.14) }}>
      <CategoryIcon category={category} size={Math.round(size * 0.55)} />
    </span>
  );
}
